import CustomErrorMessage from './CustomErrorMessage';

export default function Page500() {
  return (
    <CustomErrorMessage
      code={500}
      title="Something went wrong on our side"
      body="We couldn't load this form. Please try again in a moment."
      onRetry={() => window.location.reload()}
    />
  );
}
